import React from 'react';
import { TrendingUpIcon, TrendingDownIcon, MinusIcon, BuildingIcon } from 'lucide-react';
export interface Metric {
  label: string;
  value: string;
  previousValue?: string;
  status: 'positive' | 'warning' | 'negative' | 'neutral';
  trend: 'up' | 'down' | 'flat' | 'none';
}
interface CompanyCardProps {
  companyName: string;
  metrics: Metric[];
}
export function CompanyCard({
  companyName,
  metrics
}: CompanyCardProps) {
  const getStatusColor = (status: Metric['status']) => {
    switch (status) {
      case 'positive':
        return 'bg-light-green';
      case 'warning':
        return 'bg-gold';
      case 'negative':
        return 'bg-passion-red';
      default:
        return 'bg-tech-grey-50';
    }
  };
  const getTrendIcon = (trend: Metric['trend']) => {
    switch (trend) {
      case 'up':
        return <TrendingUpIcon className="w-4 h-4 text-light-green" data-id="element-1" />;
      case 'down':
        return <TrendingDownIcon className="w-4 h-4 text-passion-red" data-id="element-2" />;
      case 'flat':
        return <MinusIcon className="w-4 h-4 text-tech-grey-50" data-id="element-3" />;
      default:
        return null;
    }
  };
  return <div className="bg-white rounded-xl shadow-sm border border-tech-grey-25/50 overflow-hidden flex flex-col h-full hover:shadow-md transition-shadow duration-200" data-id="element-4">
      <div className="bg-tech-grey-10 px-5 py-4 border-b border-tech-grey-25/50 flex items-center gap-3" data-id="element-5">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-6">
          <BuildingIcon className="w-5 h-5" data-id="element-7" />
        </div>
        <h3 className="font-heading text-lg font-bold text-tech-grey" data-id="element-8">
          {companyName}
        </h3>
      </div>

      <div className="p-5 flex-1 flex flex-col gap-4" data-id="element-9">
        {metrics.map((metric, index) => <div key={index} className="flex items-center justify-between" data-id="element-10">
            <span className="font-body text-sm text-tech-grey-75 font-medium" data-id="element-11">
              {metric.label}
            </span>
            <div className="flex items-center gap-3" data-id="element-12">
              <div className="flex flex-col items-end" data-id="element-13">
                <span className="font-heading font-bold text-tech-grey" data-id="element-14">
                  {metric.value}
                </span>
                {metric.previousValue && <span className="font-body text-xs text-tech-grey-50" data-id="element-15">
                    von {metric.previousValue}
                  </span>}
              </div>

              <div className="flex items-center gap-1.5 w-12 justify-end" data-id="element-16">
                {metric.trend !== 'none' && <div className="flex items-center justify-center w-6 h-6 rounded-full bg-tech-grey-10" data-id="element-17">
                    {getTrendIcon(metric.trend)}
                  </div>}
                <div className={`w-3 h-3 rounded-full shadow-inner ${getStatusColor(metric.status)}`} title={`Status: ${metric.status}`} data-id="element-18" />
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}